import { gql } from 'apollo-angular'

import { MAGAZINE_BASIC_FIELDS } from '../../fragments/magazine.fragments'

export const GET_MAGAZINES = gql`
  query getMagazines($page: Int!, $itemsPerPage: Int!) {
    Magazines(
      select: true
      page: $page
      limit: $itemsPerPage
      where: { published: { equals: true } }
    ) {
      docs {
        ...MagazineBasicFields
      }
      totalDocs
    }
  }
  ${MAGAZINE_BASIC_FIELDS}
`
